import React, { Component } from 'react';
import MainHeader from '../../../components/common/MainHeader';
import FooterDesktop from '../../../components/common/FooterDesktop_bhutan';
import BhutanTourPackage from '../../../components/package/Bhutan/BhutanTourPackage';
import { Helmet } from "react-helmet";

class BhutanTourPackagePage extends Component {
    constructor() {
        super();
        this.state = {
            HotPackagesData: [],
            ThemePackagesData: [],
            HotelsData: [],
            ReviewersData: [],
        }
    }

    componentDidMount() {
        window.scroll(0, 0);
        const hotPackageDataList = [
            {
                Title: "Bhutan Tour ex Bagdogra",
                ImageName: "bhutan-trip-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-bagdogra'
            },
            {
                Title: "Bhutan B2B Package",
                ImageName: "bhutan-trip-package-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-b2b-package-tour-operator-in-india-best-bhutan-dmc'
            },
            {
                Title: "Bhutan Tour ex Mumbai",
                ImageName: "bhutan-vacation-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-mumbai'
            },
            {
                Title: "Bhutan Tour ex Delhi",
                ImageName: "bhutan-tour-packages-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "37,999",
                book: "Book Now",
                Url: '/bhutan-tour-from-delhi'
            },
            {
                Title: "Bhutan Tour ex Chennai",
                ImageName: "bhutan-tour-travel-package-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-chennai'
            },
            {
                Title: "Bhutan Tour ex Kolkata",
                ImageName: "bhutan-travel-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PARO 2N | PHUENTSHOLING 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-kolkata'
            },
            {
                Title: "Bhutan Tour ex Ahemdabad",
                ImageName: "bhutan-travel-agency-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PARO 2N | PHUENTSHOLING 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-ahemdabad'
            },
            {
                Title: "Bhutan Tour ex Hyderabad",
                ImageName: "bhutan-package-tour-from-surat-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PARO 2N | PHUENTSHOLING 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-hyderabad'
            },
            {
                Title: "Bhutan Tour ex Pune",
                ImageName: "bhutan-tour-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 1N | PHOBJIKHA 1N | WANGDUE 1N | HAA 1N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-pune'
            },
            {
                Title: "Bhutan Tour ex Bangalore",
                ImageName: "bhutan-tour-package-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "PHUENTSHOLING 1N | THIMPHU 2N | PUNAKHA 1N | PARO 2N | LATAGURI 1N",
                PricePerNight: "53,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-bangalore'
            },
            {
                Title: "Bhutan Tour ex Surat",
                ImageName: "bhutan-package-tour-from-mumbai-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 1N | PHOBJIKHA 1N | WANGDUE 1N | HAA 1N | PARO 2N",
                PricePerNight: "53,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-surat'
            },
            {
                Title: "Bhutan Guwahati Airport",
                ImageName: "bhutan-package-tour-from-nagpur-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-guwahati-airport'
            },
            {
                Title: "Bhutan Six Senses Tour",
                ImageName: "bhutan-package-tour-from-chennai-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-luxury-package-tour-with-six-senses-hotel'
            },
            {
                Title: "Bhutan Six Senses Packages",
                ImageName: "bhutan-package-tour-from-nashik-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-hotel-six-senses-package-tour-with-direct-flight-from-india'
            },
            {
                Title: "Bhutan Tour ex Hasimara",
                ImageName: "bhutan-package-tour-from-delhi-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-hasimara-new-alipurduar'
            },
            {
                Title: "Bhutan Tour ex Phuentsholing",
                ImageName: "bhutan-package-tour-from-patna-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-phuentsholing'
            },
            {
                Title: "Bhutan Tour ex NJP",
                ImageName: "bhutan-package-tour-from-guwahati-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-njp-station-siliguri-bus-stand'
            },
            {
                Title: "Bhutan Tour ex Jaigaon",
                ImageName: "bhutan-package-tour-from-pune-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "PHUENTSHOLING 2N | THIMPHU 2N | PUNAKHA 1N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-tour-package-from-jaigaon'
            },
            {
                Title: "Bhutan Tour ex Bangalore",
                ImageName: "bhutan-package-tour-from-hyerabad-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "PHUENTSHOLING 2N | THIMPHU 2N | PUNAKHA 1N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-bangalore-with-flight-from-kolkata-airport-guwahati-airport'
            },
            {
                Title: "Bhutan Tour ex Bagdogra Airport",
                ImageName: "bhutan-package-tour-from-india-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "PHUENTSHOLING 2N | THIMPHU 2N | PUNAKHA 1N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-DMC-b2b-packages-for-Bhutan-tour-from-bagdogra-airport-via-phuentsholing'
            },
            {
                Title: "Bhutan Group Tour ex Bagdogra",
                ImageName: "bhutan-package-tour-from-indore-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "PHUENTSHOLING 2N | THIMPHU 2N | PUNAKHA 1N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-group-tour-packages-from-bagdogra-airport'
            },
            {
                Title: "Bhutan Tour ex nagpur",
                ImageName: "bhutan-package-tour-from-kochi-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PARO 2N | PHUENTSHOLING 2N",
                PricePerNight: "53,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-nagpur'
            },
            {
                Title: "Bhutan Tour ex nasik",
                ImageName: "bhutan-package-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PARO 2N | PHUENTSHOLING 2N",
                PricePerNight: "53,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-nashik'
            },
            {
                Title: "Bhutan Tour ex Bhopal",
                ImageName: "bhutan-package-tour-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PARO 2N | PHUENTSHOLING 2N",
                PricePerNight: "53,899",
                book: "Book Now",
                Url: '/bhutan-package-tour-from-bhopal'
            },
            {
                Title: "Eastern Bhutan Tour",
                ImageName: "bhutan-package-tour-from-ahmedabad-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 3N | PUNAKHA 1N | TRONGSA 1N | BHUMTHUNG 2N | MONGAR 1N | TRASHIGANG 2N | POBHJIKHA 1N | WANGDUE 1N | PARO 3N",
                PricePerNight: "53,899",
                book: "Book Now",
                Url: '/eastern-bhutan-package-tour-with-trashigang-trongsa-bumthang-mongar'
            },
            {
                Title: "Bhutan 10N 11D Tour",
                ImageName: "bhutan-package-tour-from-bangalore-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 4N | TRONGSA 1N | BHUMTHUNG 2N | WANGDUE 1N | PARO 2N",
                PricePerNight: "53,899",
                book: "Book Now",
                Url: '/bhutan-10nights-11days-package-tour'
            },
            {
                Title: "Bhutan 9N 10D Tour",
                ImageName: "bhutan-package-tour-from-bhopal-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 3N | PHUENTSHOLING 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-9nights-10days-package-tour'
            },
            {
                Title: "Bhutan with Chartered Flight",
                ImageName: "bhutan-package-tour-from-bhubaneswar-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 1N | PHOBJIKHA 1N | PARO 3N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/mumbai-special-chartered-flight'
            },
            {
                Title: "Bhutan 4N 5D Tour",
                ImageName: "adorable-vacation-bhutan-best-bhutan-travel-agent-india.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-4nights-5days-package-tour'
            },
            {
                Title: "Bhutan 5N 6D Tour",
                ImageName: "adorable-vacation-bhutan-no1-bhutan-tour-operator-india.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 1N | PARO 2N",
                PricePerNight: "38,899",
                book: "Book Now",
                Url: '/bhutan-5nights-6days-package-tour'
            },
            {
                Title: "Bhutan 6N 7D Tour",
                ImageName: "adorable-vacation-bhutan-no1-bhutan-travel-agency-india.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 2N | PARO 2N",
                PricePerNight: "38,899*",
                book: "Book Now",
                Url: '/bhutan-6nights-7days-package-tour'
            },
            {
                Title: "Bhutan 8N 9D Tour",
                ImageName: "adorable-vacation-bhutan-no1-bhutan-travel-agent-india.webp",
                AllternateText: "...",
                Description: "THIMPHU 3N | PUNAKHA 2N | PARO 3N",
                PricePerNight: "38,899*",
                book: "Book Now",
                Url: '/bhutan-8nights-9days-package-tour'
            },
            {
                Title: "Bhutan 10N 11D Trip",
                ImageName: "bhutan-holidays-adorable-vacation-bhutan.webp",
                AllternateText: "...",
                Description: "THIMPHU 2N | PUNAKHA 1N | BHUMTHUNG 2N | WANGDUE 1N | PHOBJIKHA 1N | PARO 3N",
                PricePerNight: "38,899*",
                book: "Book Now",
                Url: '/10N-11D-FIFO-package'
            },
        ];

        const hotelDataList = [
            {
                HotelName: 'Hotel Ugyen, Thimpu',
                ImageName: "hotel-ugyen.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.9,
                Reviews: '50 Reviews'
            },
            {
                HotelName: 'Amodhara, Thimphu',
                ImageName: "amodhara-2.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.8,
                Reviews: '47 Reviews'
            },
            {
                HotelName: 'White Dragon, Punakha',
                ImageName: "white-dragon.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.7,
                Reviews: '46 Reviews'
            },
            {
                HotelName: 'Pema karpo, Punakha',
                ImageName: "pema-karpo.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.6,
                Reviews: '48 Reviews'
            },
            {
                HotelName: 'Layhuel, Paro',
                ImageName: "lehul.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.8,
                Reviews: '49 Reviews'
            },
            {
                HotelName: 'Tshringma, Paro',
                ImageName: "Tsherim-resort.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.7,
                Reviews: '43 Reviews'
            },
            {
                HotelName: 'Green Touch, Lataguri',
                ImageName: "green-touch.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.6,
                Reviews: '44 Reviews'
            },
            {
                HotelName: 'Suncity, Lataguri',
                ImageName: "suncity.webp",
                AllternateText: "...",
                HotelStar: '★★★',
                RatingBoxStar: '★',
                RatingValue: 4.8,
                Reviews: '40 Reviews'
            }
        ];

        const themePackageDataList = [
            {
                Title: "Bhutan Honeymoon",
                ImageName: "Bhutan-Honeymoon-Package.webp",
                AllternateText: "...",
                Description: "Bhutan Package is your ultimate destination. 7N/8D is the decent duration to explore the relation between Nature & Better Half.",
            },
            {
                Title: "Wedding at Bhutan",
                ImageName: "Destination-Wedding-at-Bhutan.webp",
                AllternateText: "...",
                Description: "Make your iconic marriage day very very special at Bhutan. Marriage like VIP, execute a super destination wedding 'LIKE NEVER BEFORE'.available.",
            },
            {
                Title: "Bhutan Solo Trip (Woman)",
                ImageName: "Bhutan-Solo-Trip-Woman-Special.webp",
                AllternateText: "...",
                Description: "Love to explore everything by yourself ? Then Bhutan is the god gifted gem for you. Numerous things are present to explore,experience & recreate.",
            },
            {
                Title: "Bhutan Adventure Trip",
                ImageName: "Bhutan-Adventure-Packages.webp",
                AllternateText: "...",
                Description: "After NEPAL, Bhutan is an amazing counter destiation for Adventure lover. Explore with thrilling activities - River Rafting, Paragliding & Kayaking etc.",
            },
            {
                Title: "Bhutan Bike Trip",
                ImageName: "Bhutan-Bike-Package-Tour.webp",
                AllternateText: "...",
                Description: "Throughout the Bhutan bike trip, you will pass through curvy roads with most picturesque surroundings with high eastern Himalayan snow-capped peaks.",
            },
            {
                Title: "Pilgrimage of Bhutan",
                ImageName: "Bhutan-Monastery-Packages.webp",
                AllternateText: "...",
                Description: "Bhutan is the only country in the world that officially practices Mahayana Buddhism or Vajrayana Buddhism. Buddhism is a way of life in Bhutan.",
            },
            {
                Title: "Bhutan Snowman Trek",
                ImageName: "Bhutan-Snowman-Trek.webp",
                AllternateText: "...",
                Description: "The Snowman Trek is the longest hiking trail of Bhutan that extends from Laya to the high Bhutanese Himalayas, covering up the northern Kingdom.",
            },
            {
                Title: "Bhutan Foreigners Package",
                ImageName: "Bhutan-Forigners-Package.webp",
                AllternateText: "...",
                Description: "As a foreigner, living in Bhutan can be a rewarding and fascinating experience,a small landlocked country in the eastern Himalayas, is known for its unique culture.",
            },

        ];

        const reviewersDataList = [
            {
                Name: "Sanil Shildhankar",
                ImageName: "sunil.webp",
                AllternateText: "...",
                Location: "@Bengaluru",
                Comment: "I recently had the pleasure of booking a tour with Adorable Tours to see Bhutan, and I must say,it was one of the most amazing experiences of my life. From first contact to the end of our trip,every aspect of the tour was handled with professionalism and care.What I loved most about this company was how they listened to our needs and adjusted the itinerary to meet them, always with a smile and willingness to make us happy. They were always accessible through WhatsApp, which made communication so much easier and convenient, especially since we were traveling with our family.",
            },
            {
                Name: "Krishna K",
                ImageName: "Krishna-K.webp",
                AllternateText: "...",
                Location: "@Delhi",
                Comment: "Our Bhutan trip was organised by Soumalya , Rewa Addorable LLP. Simply great and exotic hotels. Stay was very luxurious, food was great. Traveller bus was very smooth and luxurious. No issues with anything. The team was constantly in touch with us during the tour on WhatsApp to check everything is fine. They are at their best to provide best services to their guests. Very cooperative staff. Our guide Mr Harka and Mr Donzy were so friendly and awesome guys. Mr Soumalya was prompt , approchable , and provided a great deal and comfortable plan for us Once again would like to thank personally Mr Soumalya & their team members for arranging the best tour of Bhutan Will definitely recommend them to everyone for a memorable trip.",
            },
            {
                Name: "Rikhiya Basu",
                ImageName: "rikiya-basu.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "Had the most comfortable stay in Bhutan, thanks to adorable vacation LLp. Our guide Mr. Gyeltshen and our driver were extremely helpful and nice. They were always ready to help us out with everything. I would highly recommend Adorable Vacation LLP to everyone and would love to book our next trip with them too. Thank you team for taking care of us.",
            },
            {
                Name: "Harish Kamal",
                ImageName: "Harish-Kamal-Singh.webp",
                AllternateText: "...",
                Location: "@Mumbai",
                Comment: "I had an excellent experience with Mr. Soumalya Ghosh as our tour manager for the Bhutan trip. He was a very experienced and friendly guide and made out tour very memorable. I would love to recommend Adorable Vacation to anyone who's planning a tour to Bhutan.",
            },
        ];


        this.setState({
            HotPackagesData: hotPackageDataList,
            ThemePackagesData: themePackageDataList,
            HotelsData: hotelDataList,
            ReviewersData: reviewersDataList
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title> Bhutan Package Tour, Bhutan Tour Packages, Bhutan Tour, Bhutan Packages</title>
                    <meta name="description" content="We offer the best Bhutan Package Tour at Best Price. For Booking Bhutan Tour Packages ☎ CALL +91-98833-59713" />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "http://schema.org",
                            "@type": "Product",
                            "name": "Bhutan Package Tour Reviews",
                            "aggregateRating": {
                                "@type": "AggregateRating",
                                "ratingValue": "5.0",
                                "bestRating": "5",
                                "ratingCount": "410"
                            }
                        })}
                    </script>
                </Helmet>

                <MainHeader />
                <BhutanTourPackage
                    HotPackagesData={this.state.HotPackagesData}
                    ThemePackagesData={this.state.ThemePackagesData}
                    HotelsData={this.state.HotelsData}
                    ReviewersData={this.state.ReviewersData}
                />
                <FooterDesktop />
            </>
        );
    }
}

export default BhutanTourPackagePage;